import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=ae1308ec&"
import script from "./PrivacyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports